<template>
	<div class="integral-goods-details-container">
		<div class="backBox" @click="handleClose">
			<img class="backIcon" src="../assets/Personal/iconI.png" />
			返回
		</div>
		<div class="statusBox">
			<div class="status">
				{{details.status == 1 ? '已处理' : '未处理'}}
				<div class="time">申请时间：{{details.create_time ? details.create_time : ''}}</div>
			</div>
			¥ {{details.price ? details.price : ''}}
		</div>
		<div class="infoItemBox">
			<div class="infoItemTitle">
				订单信息
			</div>
			<div class="infoItem">
				订单类型
				<div class="itemContent">
					{{details.type && details.type == 1 ? '图片订单' : details.type && details.type == 3 ? '定制订单' : '周边订单'}}
				</div>
			</div>
			<div class="infoItem">
				订单编号
				<div class="itemContent">
					{{details.order && details.order.order_sn ? details.order.order_sn : ''}}
				</div>
			</div>
			<div class="infoItem">
				订单金额
				<div class="itemContent">
					¥{{details.order && details.order.order_price ? details.order.order_price : ''}}
				</div>
			</div>
			<div class="infoItem">
				实付金额
				<div class="itemContent">
					¥{{details.order && details.order.pay_price ? details.order.pay_price : ''}}
				</div>
			</div>
		</div>
		<div class="infoItemBox">
			<div class="infoItemTitle">
				发票信息
			</div>
			<div class="infoItem">
				开票类型
				<div class="itemContent">{{details.lx_type == 1 ? '个人' : '企业'}}</div>
			</div>
			<div class="infoItem" v-if="details.lx_type == 2">
				企业名称
				<div class="itemContent">{{details.qy_name ? details.qy_name : ''}}</div>
			</div>
			<div class="infoItem" v-if="details.lx_type == 2">
				公司税号
				<div class="itemContent">{{details.qy_num ? details.qy_num : ''}}</div>
			</div>
			<div class="infoItem">
				真实姓名
				<div class="itemContent">{{details.lxr ? details.lxr : ''}}</div>
			</div>
			<div class="infoItem">
				联系方式
				<div class="itemContent">{{details.phone ? details.phone : ''}}</div>
			</div>
			<div class="infoItem">
				邮箱
				<div class="itemContent">{{details.email ? details.email : ''}}</div>
			</div>
		</div>
		<div class="menu" v-if="details.status == 1">
			<div class="menuItem">
				<el-image style="width: 2.4rem;height: .52rem;position: absolute;top: 0;left: 0;opacity: 0;"
					:src="details.img" :preview-src-list="[details.img]" v-if="details.img">
				</el-image>
				<i class="el-icon-view"></i>
				查看发票
			</div>
			<div class="menuItem" @click="download">
				<i class="el-icon-download"></i>
				下载发票
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			goods: {
				type: Object,
				default: () => {}
			}
		},
		watch: {
			goods: {
				handler(newValue) {
					console.log(newValue)
					this.goodsDetails()
				},
				deep: true
			}
		},
		data() {
			return {
				details: {},
			}
		},
		methods: {
			handleClose() {
				this.$emit('close')
			},
			goodsDetails() {
				this.$api.post('UserD/invoice_details', {
					id: this.goods.id
				}).then(res => {
					if (res.code == 1) {
						this.details = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			download() {
				window.open(this.details.img)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.integral-goods-details-container {
		width: 100%;
		background: #FFFFFF;
		padding: .24rem .4rem;
		display: flex;
		flex-direction: column;
	}

	.backBox {
		display: flex;
		align-items: center;
		font-weight: 400;
		font-size: .14rem;
		color: #000000;
		cursor: pointer;

		.backIcon {
			width: .06rem;
			height: .1rem;
			margin-right: .06rem;
		}
	}

	.statusBox {
		margin-top: .16rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-weight: 700;
		font-size: .24rem;
		color: #FF0000;

		.status {
			display: flex;
			flex-direction: column;
			font-weight: 700;
			font-size: .24rem;
			color: #000000;

			.time {
				font-weight: 400;
				font-size: 14px;
				color: #333333;
			}
		}
	}

	.infoItemBox {
		display: flex;
		flex-direction: column;
		margin-top: .16rem;
		padding-top: .16rem;
		border-top: .01rem solid #CCCCCC;

		.infoItemTitle {
			font-weight: 600;
			font-size: .16rem;
			color: #333333;
		}

		.infoItem {
			margin-top: .08rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-weight: 400;
			font-size: .16rem;
			color: #333333;

			.itemContent {
				font-weight: 600;
			}
		}
	}

	.menu {
		display: flex;
		align-items: center;
		margin: .32rem auto .16rem;

		.menuItem {
			margin: 0 .24rem;
			display: flex;
			align-items: center;
			justify-content: center;
			font-weight: 500;
			font-size: .16rem;
			color: #252525;
			width: 2.4rem;
			height: .52rem;
			background: #EFD8B8;
			border-radius: .06rem;
			line-height: .52rem;
			cursor: pointer;
			position: relative;

			i {
				margin-right: .06rem;
			}
		}
	}
</style>